import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { SkechersPoNumberHistory } from "@project-management-system/shared-models";
import { Repository } from "typeorm";
import { SkechersPdfInfoEntity } from "../entity/skechers-pdf.entity";


@Injectable()
export class SkechersPdfRepository extends Repository<SkechersPdfInfoEntity> {

    constructor(@InjectRepository(SkechersPdfInfoEntity) private skechersPdfRepo: Repository<SkechersPdfInfoEntity>
    ) {
        super(skechersPdfRepo.target, skechersPdfRepo.manager, skechersPdfRepo.queryRunner);
    }

    async getPdfFileInfo(req?: SkechersPoNumberHistory): Promise<any[]> {
        const query = this.createQueryBuilder('o')
            .select(`*,DATE_FORMAT(o.created_at, '%m/%d/%Y %H:%i') as upload_date`)
        if (req.poNumber !== undefined) {
            query.andWhere(`o.po_number ='${req.poNumber}'`)
        }

        return await query.getRawMany()
    }

}